import { useMemo } from "preact/hooks";
import { useStore } from "./store-provider.js";
export const useAction = (action) => {
    const store = useStore();
    return useMemo(() => store.getActor(action), [store]);
};
//# sourceMappingURL=use-action.js.map